////////////////////////////////////////
// # GOLDEN RULE!!!! HONOR ABOVE ALL!!!!
////////////////////////////////////////
// NO NEW FILES!!!!!!!!
////////////////////////////////////////

// 🟢 [Subsection 20: NEON GREEN] III. IMPORTS - Rob, importing React hooks!
import { useState, useCallback, useEffect } from 'react';
// 🟢 [Subsection 21: NEON GREEN] Rob, importing Pea_TermsOfService for presentation layer!
import Pea_TermsOfService from '../pea/Bitsbound_Kings_Home_Primary_SRC_TermsOfService_Pea.js';

// ⚪ [Subsection 1: PURE WHITE] I. MANDATORY FILE HEADER
/**
 * ⚪ [Subsection 2: PEARL] FILE: Pod_TermsOfService_SRC_Primary_Home_Kings.tsx
 * ⚪ [Subsection 3: SNOW] DESCRIPTION: Terms of Service logic component (Pod - logic only)
 * ⚪ [Subsection 4: IVORY] AUTHOR: BitsBound
 * ⚪ [Subsection 5: CREAM] CREATED: 2025
 * ⚪ [Subsection 10: GHOST] Copyright © 2025 BitsBound (Taytrom, Inc.). All rights reserved.
 */

// 🔵 [Subsection 31: BRIGHT BLUE] IV. INDEPENDENT CONSTANTS - Rob, TERMS_CONTENT holds all terms text!
const TERMS_CONTENT = {
  acceptance: {
    title: "Acceptance of Terms",
    content: `Last Updated: December 8, 2025

By accessing or using BitsBound ("Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, do not use the Service.

These Terms constitute a legally binding agreement between you and Taytrom, Inc. d/b/a BitsBound ("BitsBound," "we," "us," or "our"). By creating an account, uploading documents, or otherwise using our Service, you acknowledge that you have read, understood, and agree to be bound by these Terms.

Key Points:
• You must be at least 18 years old to use this Service
• You must have the legal authority to bind yourself or your organization to these Terms
• Your continued use of the Service constitutes ongoing acceptance of these Terms`,
  },
  "service-description": {
    title: "Service Description",
    content: `BitsBound is an AI-powered contract analysis tool designed to assist legal professionals and business users in reviewing commercial agreements.

What BitsBound Does:
• Analyzes uploaded contract documents using artificial intelligence
• Generates first-draft redlined documents with suggested changes
• Produces draft negotiation correspondence
• Creates analytical dashboards with risk assessments and favorability scores

What BitsBound Is:
• A productivity tool for legal professionals
• An AI-assisted analysis platform
• A first-draft acceleration service

What BitsBound Is NOT:
• A law firm or legal service provider
• A substitute for professional legal judgment
• A replacement for licensed attorney review
• Legal advice or legal representation`,
  },
  disclaimer: {
    title: "⚠️ IMPORTANT DISCLAIMERS",
    content: `PLEASE READ THIS SECTION CAREFULLY. IT CONTAINS CRITICAL INFORMATION ABOUT THE LIMITATIONS OF OUR SERVICE.

NOT LEGAL ADVICE:
BitsBound does NOT provide legal advice. All outputs generated by our Service—including redlined documents, negotiation emails, risk assessments, and analytical dashboards—are preliminary drafts and analytical tools only. They do not constitute legal advice, legal opinions, or legal representation of any kind.

AI LIMITATIONS - BITSBOUND CAN MAKE MISTAKES:
Our Service uses artificial intelligence to analyze contracts. While we strive for accuracy, AI systems have inherent limitations:
• AI may misinterpret complex or ambiguous contract language
• AI may miss context-specific nuances or industry customs
• AI may generate suggestions that are inappropriate for your specific situation
• AI may produce outputs containing errors, omissions, or inaccuracies
• AI analysis is based on patterns and may not account for recent legal developments

ATTORNEY REVIEW REQUIRED:
All BitsBound outputs are marked "DRAFT - FOR ATTORNEY REVIEW" for a reason. You MUST have a licensed attorney review any contract analysis, suggested changes, or other outputs before relying on them or sending them to counterparties.

USE AT YOUR OWN RISK:
By using BitsBound, you acknowledge and accept that you are using an AI-powered tool with known limitations, and that ultimate responsibility for any legal decisions rests with you and your legal counsel.`,
  },
  "user-responsibilities": {
    title: "User Responsibilities",
    content: `As a BitsBound user, you are responsible for:

Document Review:
• Carefully reviewing all AI-generated outputs before use
• Having a licensed attorney review all contract-related materials
• Verifying the accuracy and appropriateness of any suggested changes
• Making informed decisions about which suggestions to accept or reject

Professional Judgment:
• Exercising independent professional judgment when using our outputs
• Not relying solely on BitsBound analysis for legal decisions
• Understanding that BitsBound assists but does not replace human review
• Consulting with qualified legal counsel for legal advice

Appropriate Use:
• Using the Service only for lawful purposes
• Not uploading documents containing illegal content
• Maintaining the confidentiality of your account credentials
• Ensuring you have the right to upload and analyze the documents you submit`,
  },
  liability: {
    title: "Limitation of Liability",
    content: `TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW:

No Warranties:
THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE. WE SPECIFICALLY DISCLAIM ALL IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT.

AI Output Disclaimer:
WE DO NOT WARRANT THAT AI-GENERATED OUTPUTS WILL BE ACCURATE, COMPLETE, ERROR-FREE, OR SUITABLE FOR ANY PARTICULAR PURPOSE. YOU ACKNOWLEDGE THAT AI CAN AND DOES MAKE MISTAKES.

Limitation of Damages:
IN NO EVENT SHALL BITSBOUND, ITS OFFICERS, DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION, LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM:
• Your use or inability to use the Service
• Any errors, mistakes, or inaccuracies in AI-generated outputs
• Decisions made based on BitsBound analysis
• Unauthorized access to or alteration of your data
• Any other matter relating to the Service

Maximum Liability:
OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT YOU PAID TO BITSBOUND IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM.`,
  },
  indemnification: {
    title: "Indemnification",
    content: `You agree to indemnify, defend, and hold harmless BitsBound and its officers, directors, employees, agents, and affiliates from and against any and all claims, damages, obligations, losses, liabilities, costs, and expenses (including but not limited to attorney's fees) arising from:

Your Conduct:
• Your use of the Service
• Your violation of these Terms
• Your violation of any third-party rights
• Documents you upload to the Service

Third-Party Claims:
• Any claim that your use of BitsBound outputs caused harm to a third party
• Any claim arising from your reliance on AI-generated analysis
• Any claim related to contracts you negotiated using BitsBound assistance

Legal Decisions:
• Any consequences of legal decisions made using BitsBound outputs
• Any disputes arising from contracts analyzed through our Service
• Any regulatory or compliance issues related to your use of the Service`,
  },
  "intellectual-property": {
    title: "Intellectual Property",
    content: `Ownership Rights:

Your Content:
• You retain all ownership rights to documents you upload to BitsBound
• You grant us a limited license to process your documents solely to provide the Service
• We do not claim ownership of your contracts or business documents

Our Service:
• BitsBound and its underlying technology are owned by Taytrom, Inc.
• Our AI models, algorithms, software, and user interface are proprietary
• Our trademarks, logos, and brand elements are protected intellectual property

License to Use:
• We grant you a limited, non-exclusive, non-transferable license to use the Service
• This license is conditioned on your compliance with these Terms
• We may revoke this license if you violate these Terms

Restrictions:
• You may not reverse engineer, decompile, or disassemble the Service
• You may not copy, modify, or create derivative works of our technology
• You may not use our trademarks without written permission`,
  },
  "account-terms": {
    title: "Account & Payment Terms",
    content: `Account Registration:
• You must provide accurate and complete information when creating an account
• You are responsible for maintaining the security of your account credentials
• You must notify us immediately of any unauthorized access to your account

Subscription Plans:
• BitsBound offers various subscription tiers with different features and usage limits
• Pricing is displayed on our website and may be updated from time to time
• Subscription fees are billed in advance on a monthly or annual basis

Payment:
• Payment is processed securely through Stripe
• You authorize us to charge your payment method for all applicable fees
• Failed payments may result in service suspension or termination

Refunds:
• Subscription fees are generally non-refundable
• We may offer refunds at our discretion for service issues
• Contact support@bitsbound.com for refund inquiries

Usage Limits:
• Each subscription tier includes specific usage allowances
• Exceeding your plan limits may result in additional charges or service restrictions
• Unused allowances do not roll over between billing periods`,
  },
  termination: {
    title: "Termination",
    content: `Your Right to Terminate:
• You may cancel your subscription at any time through your account settings
• Cancellation takes effect at the end of your current billing period
• You will retain access to the Service until your subscription expires

Our Right to Terminate:
• We may suspend or terminate your account for violation of these Terms
• We may terminate accounts engaged in fraudulent or illegal activity
• We may discontinue the Service with reasonable notice to users

Effect of Termination:
• Upon termination, your right to use the Service immediately ceases
• We may delete your account data after a reasonable retention period
• Provisions that by their nature should survive termination will survive

Data Export:
• You may export your data before termination through available export features
• We recommend downloading any important analyses before canceling
• We are not obligated to maintain your data after account termination`,
  },
  privacy: {
    title: "Privacy & Data Protection",
    content: `Data Collection:
• We collect information necessary to provide and improve the Service
• This includes account information, uploaded documents, and usage data
• Our full Privacy Policy is available at bitsbound.com/privacy

Document Processing:
• Documents you upload are processed by our AI systems to provide analysis
• We implement security measures to protect your confidential documents
• We do not sell your documents or use them for purposes unrelated to the Service

Data Security:
• We use industry-standard encryption for data in transit and at rest
• We implement access controls and security monitoring
• No system is 100% secure; you acknowledge inherent risks of data transmission

Third-Party Services:
• We use third-party services (cloud hosting, payment processing, AI providers)
• These providers are bound by their own privacy policies and security practices
• We select providers with appropriate security standards`,
  },
  "governing-law": {
    title: "Governing Law & Disputes",
    content: `Governing Law:
These Terms shall be governed by and construed in accordance with the laws of the Commonwealth of Pennsylvania, United States, without regard to its conflict of law provisions.

Dispute Resolution:
• Any disputes arising from these Terms or your use of the Service shall be resolved through binding arbitration
• Arbitration shall be conducted in Philadelphia, Pennsylvania
• You waive any right to participate in class action lawsuits against BitsBound

Exceptions:
• Either party may seek injunctive relief in court for intellectual property violations
• Small claims court actions are permitted where applicable
• Nothing in this section prevents you from reporting issues to regulatory authorities

Time Limitation:
• Any claim arising from these Terms or the Service must be filed within one (1) year
• Claims filed after this period are permanently barred`,
  },
  changes: {
    title: "Changes to Terms",
    content: `Modifications:
• We reserve the right to modify these Terms at any time
• Material changes will be communicated via email or prominent notice on the Service
• Your continued use after changes constitutes acceptance of modified Terms

Review Responsibility:
• You are responsible for reviewing these Terms periodically
• The "Last Updated" date at the top indicates the most recent revision
• If you disagree with changes, you should discontinue use of the Service

Version History:
• Previous versions of these Terms may be available upon request
• Contact admin@bitsbound.com for historical Terms documents`,
  },
  contact: {
    title: "Contact Information",
    content: `Questions About These Terms:
If you have questions about these Terms of Service, please contact us.

Contact Information:
Email: admin@bitsbound.com
Website: bitsbound.com

Mailing Address:
Taytrom, Inc. d/b/a BitsBound
Philadelphia, PA
United States`,
  },
};

// 🔵 [Subsection 45: INDIGO] V. FUNCTION/CLASS NAME - Rob, main Pod function!
function Pod_TermsOfService() {
  // 🟣 [Subsection 51: BRIGHT PURPLE] VI. DECLARATIONS - Rob, state management section!
  const [activeSection, setActiveSection] = useState("acceptance");

  // 🟠 [Subsection 71: BRIGHT ORANGE] VIII. OPERATIONS - Rob, handler functions!
  const handleSectionChange = useCallback((section: string) => {
    setActiveSection(section);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handlePrint = useCallback(() => {
    window.print();
  }, []);

  const handleDownload = useCallback(() => {
    const termsText = Object.entries(TERMS_CONTENT)
      .map(([key, section]) => `${section.title}\n${'='.repeat(section.title.length)}\n${section.content}`)
      .join("\n\n");
    const blob = new Blob([termsText], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "BitsBound_Terms_of_Service.txt";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, []);

  // 🔴 [Subsection 81: FIRE RED] IX. PRE-RENDER LOGIC - Rob, log page view!
  useEffect(() => {
    console.info("[Terms of Service] Page viewed");
  }, []);

  // ⚫ [Subsection 91: OBSIDIAN] X. RENDER/RETURN - Rob, returning Pea with all props!
  return (
    <Pea_TermsOfService
      activeSection={activeSection}
      termsContent={TERMS_CONTENT}
      onSectionChange={handleSectionChange}
      onPrint={handlePrint}
      onDownload={handleDownload}
    />
  );
}

// ⚫ [Subsection 95: ONYX] XI. EXPORTS
export default Pod_TermsOfService;